import { IWithMoney, Price, Product, Store } from '@Generated/graphql'
import { getBaseAttribute } from '@Globals/CMS/ProductHelpers'

export interface ChipOptions {
  freeDelivery: boolean
  isNew: boolean
  price?: Price
  productType?: string
  showChips: boolean
}

type GetChipAssetsArgs = {
  product?: Product
  store?: Store
}

export const getChipAssets = ({ product, store }: GetChipAssetsArgs): ChipOptions => {
  const { value: freeDeliveryThreshold } = store?.config?.freeShippingThreshold as IWithMoney || 0
  const isNew = getBaseAttribute<boolean>(product?.masterVariant?.attributes || [], 'isNew') || false
  const { price } = product?.masterVariant || {}
  const freeDelivery = !!(freeDeliveryThreshold && price?.value && (freeDeliveryThreshold < price.value))

  const showChips = !!(isNew || (price?.discount?.percent || price?.discount?.code?.context !== '') || freeDelivery) || product?.type === 'glasses'
  return {
    isNew,
    price: price ?? undefined,
    showChips,
    freeDelivery,
    productType: product?.type || '',
  }
}
